import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Button = ({
  onClick,
  iconRight,
  iconLeft,
  disabled,
  primary,
  secondary,
  hasBgRed,
  className,
  text,
  children,
  size,
  loading,
  ...props
}) => (
  <button
    className={clsx("rd--button", className, size, {
      ["primary"]: primary,
      ["secondary"]: secondary,
      ["hasBgRed"]: hasBgRed && !disabled,
      ["loading"]: loading,
    })}
    onClick={!loading ? onClick : null}
    disabled={disabled}
    {...props}
  >
    {loading ? (
      <div className="rd--loader">
        <div className="rd--spinner" />
      </div>
    ) : (
      <>
        {iconLeft && <div className="">{iconLeft}</div>}
        {text && text.trim().length > 0 && <span>{text}</span>}
        {iconRight && <div className="">{iconRight}</div>}
        {children}
      </>
    )}
  </button>
);

Button.propTypes = {
  onClick: PropTypes.func,
  iconRight: PropTypes.node,
  iconLeft: PropTypes.node,
  /**
   * Should be `true` if component is over a red background.
   */
  primary: PropTypes.bool,
  /**
   * Should be `true` for an outlined variant.
   */
  secondary: PropTypes.bool,
  /**
   * Should be `true` if component is over a red background.
   */
  hasBgRed: PropTypes.bool,
  className: PropTypes.string.isRequired,
  /**
   * Should be `true` when only text should be displayed.
   */
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

Button.defaultProps = {
  onClick: () => {},
  className: "",
  text: "",
  disabled: false,
  loading: false,
};

export default Button;
